/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import LoginForm from './LoginForm';


import './style.scss';

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);

  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.title = 'Cablevideo Digital | Ingresar';
  }

  render() {
    const { translate } = this.props;

    return (
      <Container fluid={true} className="cbv-body">
        <div className="row h-100">
          <div className="col-sm-12 my-auto">
            <Row>
              <Col sm="4"></Col>
              <Col sm="4">
                {
                  this._validateParams()
                    ? <LoginForm
                      api={this.api}
                      location={this.props.location}
                    />
                    : <RequestLoginErrorMessage
                      onlyMessage={true}
                      message={translate('RequestLoginErrorMessage')}
                    />
                }
              </Col>
              <Col sm="4"></Col>
            </Row>
          </div>
        </div>
      </Container>
    );
  }
}

export default WithLocalize(Login);
